<template>
  <div class="home">
    <div class="card mt-3">
      <header class="card-header">
        <p class="card-header-title has-background-info-dark has-text-info-light">
          CW statistika
        </p>
      </header>
      <div class="notification is-info mt-4 mx-4 mb-4">
        <strong>Statistike odigranih borbi igrača klana</strong>
        <p>U CW kategoriju računaju se:</p>
        <div class="content">
          <ul>
            <li>PvP Clan War borbe</li>
            <li>Duel Clan War borbe (duel se računa kao <strong>DVIJE</strong> odigrane borbe!)</li>
          </ul>
        </div>
        <p>
          Pod ostalo idu sve druge borbe (<strong>Boat battles</strong>, ladder, 2v2, turniri itd.)
        </p>
      </div>
      <div class="card-content mt-4 pt-0">
        <div class="columns">
          <div class="column">
            <ClanWeek />
          </div>
          <div class="column">
            <ClanMonth />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClanWeek from '@/components/cw/ClanWeek.vue';
import ClanMonth from '@/components/cw/ClanMonth.vue';

export default {
  components: {
    ClanWeek,
    ClanMonth,
  },
};
</script>
